import {
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  Button,
  Form,
  CardBody,
  Table,
  FormCheck,
  Alert,
  CardFooter,
  Breadcrumb,
  InputGroup,
  Tabs,
  Tab,
  Nav,
  Spinner
} from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaPlus } from 'react-icons/fa';
import { NavLink, useNavigate } from "react-router-dom";
import { getUsers, updateStatus, resetStore, updatePassword, getPendingUsers, updatePendingUserStatus, createUser } from "../../slices/userReducer";
import { CURRENT_PAGE, PER_PAGE, USER_ROLES } from "../../constants/user";
import PaginationComponent from "../common/Pagination";
import useCheckAuthorization from "../../hooks/checkAuthorization";
import { PAGE_PERMISSIONS, CRUD_PERMISSIONS, RESTRICT_ASSIGN_ROLES } from "../../constants/user";
import UpdatePasswordModal from "./UpdatePasswordModal";
import Loader from "../common/Loader";
import UserForm from "./UserForm";
import { FiEye, FiSettings } from "react-icons/fi";
import { BiLinkAlt } from "react-icons/bi";
import { truncateText } from "../../utils";
import toast from "react-hot-toast";
import { extractErrorMessage } from "../../constants/common";
import useSidebar from "../../hooks/useSidebar";
export default function UserList() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [current_page, setCurrentPage] = useState(CURRENT_PAGE)
  const searchRef = useRef()
  const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [activeTab, setActiveTab] = useState("userList");
  const [isActiveState, setIsActiveState] = useState(null);
  const {
    data,
    loading,
    pendingData,
    total_count,
    total_pending_count
  } = useSelector((state) => state.user)
  const dispatch = useDispatch();
  const [isUpdate, setIsUpdate] = useState(false);
  const navigate = useNavigate();

  const hasPermission = useCheckAuthorization(PAGE_PERMISSIONS.user)
  const addPermission = useCheckAuthorization(CRUD_PERMISSIONS.user.add)
  const disablePermission = useCheckAuthorization(CRUD_PERMISSIONS.user.delete)
  const editPermission = useCheckAuthorization(CRUD_PERMISSIONS.user.edit)
  const assignPermission = useCheckAuthorization(CRUD_PERMISSIONS.user.assign)
  const { role_id } = useSelector(state => state.common)
  const { collapse, expand, isSidebarCollapsed } = useSidebar();
  const handleUpdatePasswordModalClose = async () => {
    expand();
    dispatch(resetStore());
    setShowUpdatePasswordModal(false);
  }

  const updatePasswordSubmit = async (formData, id) => {
    const { newPassword: new_password, repeatPassword: confirm_new_password } = formData;

    try {
      await dispatch(updatePassword({ data: { new_password, confirm_new_password }, id })).unwrap();
      // Success case
      toast.success("Password updated successfully");
      handleUpdatePasswordModalClose();
    } catch (error) {
      // Error case
      const message = extractErrorMessage(error);
      toast.error(message || "Failed to update password");
    }
  };

  const handleTabSelect = (tabName) => {
    console.log("Selected tab:", tabName);
    setActiveTab(tabName);
  };

  useEffect(() => {
    if (!hasPermission) {
      navigate('/authorization-error');
    }
  }, [hasPermission])


  useEffect(() => {
    setCurrentPage(CURRENT_PAGE)
    if (activeTab === 'userList')
      dispatch(getUsers({ page: current_page, is_active: isActiveState }))
    if (activeTab === 'pendingUsers')
      dispatch(getPendingUsers({ page: current_page }))
  }, [activeTab, isActiveState])

  const switchToggle = (id, e) => {
    const isActive = e.target.checked;
    const searchText = searchRef.current.value.trim();
    dispatch(updateStatus({ id, active: isActive, page: current_page, search: searchText,isActiveState:isActiveState }))
      .unwrap()
      .then((response) => {
        toast.success(response?.message || "Status updated successfully");
      })
      .catch((error) => {
        toast.error(error?.message || "Failed to update status");
      });
  };
  const handlePagination = (number) => {
    setCurrentPage(number)
    if (activeTab === 'userList')
      dispatch(getUsers({ page: number, is_active: isActiveState }))
    if (activeTab === 'pendingUsers')
      dispatch(getPendingUsers({ page: number }))
  }

  const handleSearch = () => {
    const searchText = searchRef.current.value.trim();
    if (searchText) {
      if (activeTab === 'userList') {
        dispatch(getUsers({ page: current_page, search: searchText, is_active: isActiveState }))
      } else if (activeTab === 'pendingUsers') {
        dispatch(getPendingUsers({ page: current_page, search: searchText }))
      }
    } else {
      if (activeTab === 'userList') {
        dispatch(getUsers({ page: current_page, is_active: isActiveState }))
      } else if (activeTab === 'pendingUsers') {
        dispatch(getPendingUsers({ page: current_page }))
      }
    }
  }

  const handleShowAddUser = () => {
    setIsUpdate(false);
    setSelectedUser('')
    setShowOffcanvas(true);
  };

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
  };

  const handleSubmitUser = (data) => {
    const {
      name,
      email,
      user_role: role,
      phone
    } = data;

    // Return the Promise from dispatch
    return dispatch(createUser({ name, email, role, phone }))
      .unwrap()
      .then((response) => {
        toast.success(response?.message || "User created successfully");
        setShowOffcanvas(false);
      })
      .catch((error) => {
        // Handle the specific case where validation errors are in 'data' field
        let processedError = error;

        // Check if error has the structure with 'data' field containing validation errors
        const errorResponse = error?.response?.data || error?.response || error;
        if (errorResponse?.type === "validation_error" && errorResponse?.data && !errorResponse?.errors) {
          // Transform the error structure to match what extractErrorMessage expects
          processedError = {
            ...error,
            response: {
              ...error.response,
              data: {
                ...errorResponse,
                errors: errorResponse.data // Map 'data' to 'errors'
              }
            }
          };
        }

        const message = extractErrorMessage(processedError);
        toast.error(message || "Failed to create user");

        // Re-throw the error so it can be caught by the form
        throw error;
      });
  };

  const handleUserProcess = (user) => {
    navigate(`/employee/${user.id}`);
  }

  useEffect(() => {
    dispatch(resetStore());
  }, [])

  const handleStatusChange = (e) => {
    setCurrentPage(1);
    const value = e.target.value;
    if (value === 'active') {
      setIsActiveState(true);
    } else if (value === 'inactive') {
      setIsActiveState(false);
    } else {
      setIsActiveState(null);
    }
  };

  return (
    <>
      <Container>
        <>
          <Row>
            <Col className="mr-auto text-center">
              <Breadcrumb>
                <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: '/' }}>Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item active>Users List</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
          <Row>
            <Col sm={12} >
              <div className=" d-flex justify-content-between align-items-center">
                <h2 className="fs-3 fw-semibold">User Management</h2>
                {addPermission && (
                  <Button className="d-flex align-items-center fw-semibold" variant="primary" onClick={handleShowAddUser}>
                    <FaPlus className="me-2" />
                    Add New User
                  </Button>
                )}
              </div>
              <Card className="border-0">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between">
                    <Nav variant="underline" activeKey={activeTab} onSelect={handleTabSelect}>
                      <Nav.Item>
                        <Nav.Link eventKey="userList" className="text-primary">User List</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="pendingUsers" className="text-primary">Pending Users</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <div className="d-flex align-items-center gap-2">
                      {activeTab === "userList" && (<Form.Select className="w-auto" onChange={handleStatusChange}>
                        <option value="">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </Form.Select>
                    )}
                      <InputGroup className="w-auto">
                        <Form.Control
                          placeholder="Search user name..."
                          ref={searchRef}
                          className='border-2'
                        />
                        <Button variant="outline-secondary" onClick={handleSearch} className='border-1'>
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroup>

                    </div>
                  </div>
                </Card.Header>

                <Card.Body>
                  {activeTab === 'userList' && (
                    <>
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          {data.length === 0 ? (
                            <span>No Users Found</span>
                          ) : (
                            <Table responsive className="core-ui-table">
                              <thead>
                                <tr>
                                  <th className="text-left">Name</th>
                                  <th className="text-left">Contact</th>
                                  <th className="text-left">Email</th>
                                  <th className="text-left">Role</th>
                                  <th className="text-center">Status</th>
                                  <th className="text-center">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.map((user) => (
                                  <tr key={user.id}>
                                    <td className="text-left">{truncateText(user.name, 30)}</td>
                                    <td className="text-left">{truncateText(user.phone, 10)}</td>
                                    <td className="text-left">{truncateText(user.email, 30)}</td>
                                    <td className="text-left">{truncateText(user.role.name, 30)}</td>
                                    <td className="text-center">
                                      <FormCheck
                                        inline
                                        id={`userStatus-${user.id}`}
                                        type="switch"
                                        checked={user.active}
                                        onChange={(e) => switchToggle(user.id, e)}
                                        disabled={!disablePermission}
                                      />
                                    </td>
                                    <td className="text-center">
                                      <div className="d-flex gap-1 justify-content-center">
                                        <Button
                                          variant="link"
                                          title="View Employee"
                                          onClick={() => navigate(`/employee/${user.id}`)}
                                        >
                                          <FiEye size={18} />
                                        </Button>
                                        <Button
                                          variant="link"
                                          title="Update Password"
                                          onClick={() => {
                                            collapse();
                                            setSelectedUser(user);
                                            setShowUpdatePasswordModal(true);
                                            dispatch(resetStore());
                                          }}
                                        >
                                          <FiSettings size={18} />
                                        </Button>
                                        {assignPermission && (
                                          <NavLink to={`assign-client/${user.id}`}>
                                            <Button variant="link" title="Assign Clients">
                                              <BiLinkAlt size={18} />
                                            </Button>
                                          </NavLink>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {activeTab === 'pendingUsers' && (
                    <>
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          {pendingData.length === 0 ? (
                            <span className="text-center">No Pending Users Found</span>
                          ) : (
                            <Table responsive className="core-ui-table">
                              <thead>
                                <tr>
                                  <th className="text-left">Name</th>
                                  <th className="text-left">Contact</th>
                                  <th className="text-left">Email</th>
                                  <th className="text-left">Role</th>
                                  <th className="text-center">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pendingData.map((user) => (
                                  <tr key={user.id}>
                                    <td className="text-left">{truncateText(user.name, 30)}</td>
                                    <td className="text-left">{truncateText(user.phone, 10)}</td>
                                    <td className="text-left">{truncateText(user.email, 30)}</td>
                                    <td className="text-left">{truncateText(user.role.name, 30)}</td>
                                    <td className="text-center">
                                      <div className="d-flex gap-1 justify-content-center">
                                        <Button
                                          variant="outline-primary"
                                          className="no-hover fw-bold"
                                          style={{ width: '100px' }}
                                          size="sm"
                                          onClick={() => handleUserProcess(user)}
                                        >
                                          Process
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Card.Body>
                {!loading && (
                  <Card.Footer className="border-0">
                    <div className="d-flex justify-content-center">
                      <PaginationComponent
                        total_count={activeTab === 'userList' ? total_count : total_pending_count}
                        current_page={current_page}
                        handleOnClick={handlePagination}
                        per_page={PER_PAGE}
                      />
                    </div>
                  </Card.Footer>
                )}
              </Card>
            </Col>
          </Row>
          <UpdatePasswordModal showModal={showUpdatePasswordModal} selectedUser={selectedUser} handleModalClose={handleUpdatePasswordModalClose} submitAction={updatePasswordSubmit} />
          <UserForm
            show={showOffcanvas}
            onHide={handleCloseOffcanvas}
            submitFunc={handleSubmitUser}
            isUpdate={isUpdate}
            user={selectedUser}
          />
        </>
      </Container>
    </>
  );
}